export const DE = {
    cancel: "Abbrechen",
    submit: "Abschicken",
    message: "Nachricht",
    feedback: "Feedback",
    tooltipLabel: "Für ein Feedback klicken Sie bitte hier",
    tooltipText: "Feedback",
    feedbackSuccessfullySent: "Vielen Dank! Das Feedback wurde erfolgreich verschickt.",
    close: "Schließen",
    error: {
        sendingFailed: "Wir konnten das Feedback leider nicht verarbeiten :-(. Bitte versuchen Sie es erneut oder kontaktieren Sie support@21re.de.",
        unauthorized: "Sie müssen eingeloggt sein um das Feedback-Formular zu verwenden. Gerne nehmen wir Ihr Feedback unter support@21re.de entgegen.",
    },
};
//# sourceMappingURL=de.js.map